import React from 'react';
import classnames from 'classnames';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import { useSubscriptionTier } from '../../../../utils/hooks/useSubscriptionTier';
import TextRenderer from '../../../../TextRenderer';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import StatusTiptapViewer from '@wix/da-editor-tiptap/pkg/components/Viewer/presets/Status';
import legacyTheme from '../../feedcard.legacy.theme.scss';
import s from './LongStatus.scss';
const LongStatusFeedCardContents = ({ deviation })=>{
    const { tier } = useSubscriptionTier(deviation);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, !!tier && /*#__PURE__*/ React.createElement(PromoBadge, {
        badgeType: "tier",
        size: 40,
        className: s['tier-badge']
    }), /*#__PURE__*/ React.createElement(TextRenderer, {
        textContent: deviation.textContent,
        viewerKey: deviation.deviationId,
        legacyTheme: "status",
        className: classnames(s['content'], legacyTheme['legacy'], legacyTheme['override']),
        tipTapViewer: StatusTiptapViewer,
        cookieType: MeasuredCookieType.BROWSE_POST_FEED,
        defaultSize: {
            desktop: {
                width: 600,
                height: 600
            },
            mobile: {
                width: 380,
                height: 400
            }
        },
        tipTapPresetId: "deviation-status"
    }));
};
LongStatusFeedCardContents.displayName = 'LongStatusFeedCardContents';
export default LongStatusFeedCardContents;

//# sourceMappingURL=LongStatus.js.map